import React, { useRef } from 'react';
import AngelHeroSection from '../../../components/landingPage/AngelNetworksPage/AngelHeroSection';
import AngelStatBand from '../../../components/landingPage/AngelNetworksPage/AngelStatBand';
import AngelProblemSection from '../../../components/landingPage/AngelNetworksPage/AngelProblemSection';
import AngelFlowsSection from '../../../components/landingPage/AngelNetworksPage/AngelFlowsSection';
import AngelChangesSection from '../../../components/landingPage/AngelNetworksPage/AngelChangesSection';
import AngelQuotesSection from '../../../components/landingPage/AngelNetworksPage/AngelQuotesSection';
import AngelPricingSection from '../../../components/landingPage/AngelNetworksPage/AngelPricingSection';
import AngelCtaSection from '../../../components/landingPage/AngelNetworksPage/AngelCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const AngelsNetworks = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <AngelHeroSection />
            <AngelStatBand />
            <AngelProblemSection />
            <AngelFlowsSection />
            <AngelChangesSection />
            <AngelQuotesSection />
            <AngelPricingSection />
            <AngelCtaSection />
        </div>
    );
};

export default AngelsNetworks;
